export const CHANGE_NETWORK = 'CHANGE_NETWORK'
export const CLEAR_NETWORK = 'CLEAR_NETWORK'
